"use client"

import * as React from "react"

const ModalScrollLockContext = React.createContext(false)

/** Wraps a modal dialog's content, so popovers opened inside it join its scroll lock */
function ModalScrollLockScope({ children }: { children: React.ReactNode }) {
  return <ModalScrollLockContext.Provider value>{children}</ModalScrollLockContext.Provider>
}

/** True inside a ModalScrollLockScope */
function useInsideModalScrollLock() {
  return React.useContext(ModalScrollLockContext)
}

export { ModalScrollLockScope, useInsideModalScrollLock }
